import React from 'react';
import TextInput, { Props as InputProps } from './TextInput';
import { useFormInput } from 'hooks/useFormInput';
import { LabelValue } from 'types';
import { MenuItem } from '@material-ui/core';

interface Props extends InputProps {
  name: string;
  items?: LabelValue[];
}

const FormikInput: React.FC<Props> = (props) => {
  const { name, onBlur, onChange, onFocus, items = [], select: isSelect, ...restOfProps } = props;
  const { value, error, hasError, handleBlur, handleChange } = useFormInput({
    name,
    onBlur,
    onChange,
    onFocus,
  });

  const renderSelectItems = () =>
    items.map(({ label, value }: LabelValue, idx: number) => (
      <MenuItem key={`${idx}-value`} value={value}>
        {label}
      </MenuItem>
    ));

  return (
    <TextInput
      name={name}
      value={value || ''}
      errorMessage={hasError && error}
      onBlur={handleBlur}
      onChange={handleChange}
      select={isSelect}
      // onFocus={handleFocus}
      {...restOfProps}
    >
      {isSelect && renderSelectItems()}
    </TextInput>
  );
};

export default FormikInput;
